export default __webpack_public_path__ + "static/media/laptop.d608a31b.svg";